import PropTypes from 'prop-types';

import { DialogContent } from '../Dialog';
import { cn } from '../lib/utils';
import dialogStyles from './index.module.scss';

/**
 * Pop-up frame shared by the modal pop-ups: a full-screen layer that scrolls, holding
 * the panel, so a long step scrolls the screen rather than the panel.
 *
 * @param {string} className Extra class for the panel.
 */
const DialogFrame = ({ className, children }) => (
    <DialogContent overlay className={dialogStyles.overlay}>
        <div className={cn(dialogStyles.dialog, className)}>{children}</div>
    </DialogContent>
);

DialogFrame.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default DialogFrame;
